import { render } from "./NavCard.vue?vue&type=template&id=e8167aba&scoped=true&ts=true"
import script from "./NavCard.vue?vue&type=script&lang=ts"
export * from "./NavCard.vue?vue&type=script&lang=ts"

import "./NavCard.vue?vue&type=style&index=0&id=e8167aba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8167aba"]])

export default __exports__